import { render, staticRenderFns } from "./TimetableItemOT.vue?vue&type=template&id=25c10618&scoped=true&"
import script from "./TimetableItemOT.vue?vue&type=script&lang=js&"
export * from "./TimetableItemOT.vue?vue&type=script&lang=js&"
import style0 from "./TimetableItemOT.vue?vue&type=style&index=0&id=25c10618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c10618",
  null
  
)

export default component.exports